<template>
  <div style="padding: 0 16px">
    <a-skeleton :loading="spinning" active avatar>
      <a-table :columns="columns" :pagination="false" :data-source="records" size="small" row-key="index">
        <span slot="number" slot-scope="record">{{ record.index }}</span>
        <span slot="operator" slot-scope="operator">{{ operator ? operator.nickname : '系统' }}</span>
        <span slot="diffItem" slot-scope="record">
          <div v-for="(item, key) in record.value_diff" :key="key">{{ item.label }}</div>
        </span>
        <!-- <span slot="before" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="item.value === 'title'">{{ item.before || '--' }}</div>
              <div v-else-if="item.value === 'status'">
                <a-tag v-if="item.before !== null && ticketStatus[item.before]" :color="ticketStatus[item.before].color">{{ ticketStatus[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'urgency'">{{ item.before !== null ? problemUrgencys[item.before].label : '--' }}</div>
              <div v-else-if="item.value === 'channel'">{{ item.before !== null ? problemChannels[item.before].label : '--' }}</div>
              <div v-else-if="item.value === 'frequency'">
                <a-tag v-if="item.before !== null" :color="problemFrequencys[item.before].color">{{ problemFrequencys[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'level'">
                <a-tag v-if="item.before !== null" :color="ticketLevel[item.before].color">{{ ticketLevel[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'domain'">
                <a-tag v-if="item.before !== null" :color="ticketDomain[item.before].color">{{ ticketDomain[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'tags'">
                <a-tag v-if="item.before !== null" :color="ticektTag[item.before].color">{{ ticektTag[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'content'">
                <a-popover title="描述" placement="topRight">
                  <template slot="content">
                    <vditor-preview :content="item.before" />
                  </template>
                  <a v-if="item.before !== null">查看详情</a>
                  <span v-else>--</span>
                </a-popover>
              </div>
              <div v-else-if="item.value === 'problem_type'">
                <a-badge v-if="item.before !== null" :color="problemTypes[item.before].color" :text="problemTypes[item.before].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'attribution'">
                <a-popover title="归因分析" placement="topRight">
                  <template slot="content">
                    <vditor-preview :content="item.before" />
                  </template>
                  <a v-if="item.before !== null">查看详情</a>
                  <span v-else>--</span>
                </a-popover>
              </div>
              <div v-if="item.value === 'tags'">{{ item.before ? item.before.map(item => item.name).join('; ') : '--' }}</div>
              <div v-else-if="item.value === 'domains'">{{ item.before ? item.before.map(item => item.name).join('; ') : '--' }}</div>
              <div v-else-if="item.value === 'projects'">{{ item.before ? item.before.map(item => item.name).join('; ') : '--' }}</div>
              <div v-else-if="item.value === 'handler'">{{ item.before ? item.before.nickname : '--' }}</div>
              <div v-else-if="item.value === 'maintainer'">{{ item.before ? item.before.nickname : '--' }}</div>
              <div v-else-if="item.value === 'reporter'">{{ item.before ? item.before.nickname : '--' }}</div>
              <div v-else-if="item.value === 'solver'">{{ item.before ? item.before.nickname : '--' }}</div>
              <div v-else-if="item.value === 'started_time'">{{ item.before ? item.before : '--' }}</div>
              <div v-else-if="item.value === 'reported_time'">{{ item.before ? item.before : '--' }}</div>
              <div v-else-if="item.value === 'resolved_time'">{{ item.before ? item.before : '--' }}</div>
              <div v-else>--</div>
            </span>
          </span>
        </span> -->
        <span slot="after" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="item.value === 'title'">{{ item.after || '--' }}</div>
              <div v-else-if="item.value === 'status'">
                <a-tag v-if="item.after !== null && ticketStatus[item.after]" :color="ticketStatus[item.after].color">{{ ticketStatus[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'urgency'">{{ item.after !== null ? problemUrgencys[item.after].label : '--' }}</div>
              <div v-else-if="item.value === 'channel'">{{ item.after !== null ? problemChannels[item.after].label : '--' }}</div>
              <div v-else-if="item.value === 'frequency'">
                <a-tag v-if="item.after !== null" :color="problemFrequencys[item.after].color">{{ problemFrequencys[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'level'">
                <a-tag v-if="item.after !== null" :color="ticketLevel[item.after].color">{{ ticketLevel[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'domain'">
                <a-tag v-if="item.after !== null" :color="ticketDomain[item.after].color">{{ ticketDomain[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'qiyu_ticket_status'">
                <a-tag v-if="item.after !== null" :color="qiyuTicketStatus[item.after].color">{{ qiyuTicketStatus[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'tags'">
                <a-tag v-if="item.after !== null">{{ getTagTitle(item.after) }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'content'">
                <a v-if="item.after !== null" @click="onPreview(item.after, '「变更后」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'problem_type'">
                <a-badge v-if="item.after" :color="problemTypes[item.after].color" :text="problemTypes[item.after].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'attribution'">
                <a v-if="item.after !== null" @click="onPreview(item.after, '「变更后」归因分析')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'domains'">{{ item.after ? item.after.map(item => item.name).join('; ') : '--' }}</div>
              <div v-else-if="item.value === 'projects'">{{ item.after ? item.after.map(item => item.name).join('; ') : '--' }}</div>
              <div v-else-if="item.value === 'handler'">{{ item.after ? item.after : '--' }}</div>
              <div v-else-if="item.value === 'maintainer'">{{ item.after ? item.after : '--' }}</div>
              <div v-else-if="item.value === 'reporter'">{{ item.after ? item.after.nickname : '-/-' }}</div>
              <div v-else-if="item.value === 'solver'">{{ item.after ? item.after.nickname : '--' }}</div>
              <div v-else-if="item.value === 'started_time'">{{ item.after ? item.after : '--' }}</div>
              <div v-else-if="item.value === 'reported_time'">{{ item.after ? item.after : '--' }}</div>
              <div v-else-if="item.value === 'resolved_time'">{{ item.after ? item.after : '--' }}</div>
              <div v-else>--</div>
            </span>
          </span>
        </span>
      </a-table>
    </a-skeleton>
    <preview-modal ref="previewModal" />
  </div>
</template>

<script>
import { ticketRecord } from '@/api/event/problem';
import PreviewModal from '@/pages/project/components/PreviewModal';
import { problemUrgencys, problemChannels, problemFrequencys, problemTypes, problemStatus, faultLevels, qiyuTicketStatus } from '@/utils/dictionary';
import { ticketLevel, ticektTag, ticketDomain, ticketStatus } from '@/utils/dictionary';
const columns = [
  {
    title: '序号',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'number' }
  },
  {
    title: '操作人',
    width: '10%',
    align: 'center',
    dataIndex: 'operator',
    key: 'operator',
    scopedSlots: { customRender: 'operator' }
  },
  {
    title: '操作时间',
    width: '15%',
    align: 'center',
    key: 'created_time',
    dataIndex: 'created_time'
  },
  {
    title: '变更类型',
    width: '10%',
    align: 'center',
    key: 'operation_alias',
    dataIndex: 'operation_alias'
  },
  {
    title: '变更项',
    width: '10%',
    align: 'center',
    scopedSlots: { customRender: 'diffItem' }
  },
  // {
  //   title: '变更前',
  //   align: 'center',
  //   width: '25%',
  //   scopedSlots: { customRender: 'before' }
  // },
  {
    title: '变更为',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'after' }
  }
];
export default {
  components: { PreviewModal },
  props: {
    sourceId: {
      type: [Number, String],
      default: null
    },
    ticketTagList: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      columns,
      faultLevels,
      problemTypes,
      ticketDomain,
      ticketStatus,
      ticektTag,
      ticketLevel,
      problemStatus,
      problemUrgencys,
      problemChannels,
      qiyuTicketStatus,
      problemFrequencys,
      spinning: true,
      projectId: parseInt(this.$route.params.project_id) || null,
      records: [],
      recordItems: {
        title: { value: 'title', label: '标题' },
        level: { value: 'level', label: '紧急程度' },
        status: { value: 'status', label: '当前状态' },
        domain: { value: 'domain', label: '业务域' },
        qiyu_ticket_status: { value: 'qiyu_ticket_status', label: '渠道工单状态' },
        tags: { value: 'tags', label: '问题类型' },
        urgency: { value: 'urgency', label: '严重程度' },
        channel: { value: 'channel', label: '反馈去掉' },
        frequency: { value: 'frequency', label: '出现频率' },
        priority: { value: 'priority', label: '优先级' },
        solver: { value: 'solver', label: '解决人' },
        handler: { value: 'handler', label: '处理人' },
        maintainer: { value: 'maintainer', label: '负责人' },
        reporter: { value: 'reporter', label: '反馈人' },
        content: { value: 'content', label: '描述' },
        domains: { value: 'domains', label: '业务域' },
        projects: { value: 'projects', label: '项目' },
        attribution: { value: 'attribution', label: '归因' },
        problem_type: { value: 'problem_type', label: '类型' },
        started_time: { value: 'started_time', label: '开始时间' },
        reported_time: { value: 'reported_time', label: '上报时间' }
      }
    };
  },
  computed: {
    diff() {
      return data => {
        const items = [];
        const itemKeys = Object.keys(this.recordItems);
        for (const key in data) {
          if (itemKeys.includes(key)) {
            items.push({
              ...this.recordItems[key],
              ...data[key]
            });
          }
        }
        return items;
      };
    }
  },
  created() {
    if (this.sourceId !== null) this.getProblemRecord();
  },
  methods: {
    getTagTitle(key) {
      const node = this.findNodeByKey(this.ticketTagList, key);
      if (node) {
        return node.title;
      }
      return '';
    },
    findNodeByKey(tree, key) {
      for (const node of tree) {
        if (node.key === key) {
          return node;
        }
        if (node.children) {
          const foundNode = this.findNodeByKey(node.children, key);
          if (foundNode) {
            return foundNode;
          }
        }
      }
      return null;
    },
    getProblemRecord() {
      ticketRecord({ id: this.sourceId })
        .then(res => {
          this.records = res.data.items.map((record, index) => {
            return {
              index: index + 1,
              ...record,
              value_diff: this.diff(record.value_diff)
            };
          });
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    },
    onPreview(content, title) {
      this.$nextTick(() => {
        this.$refs.previewModal.onOpen(content, title);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.diff-item {
  display: block;
}

.ql-container.ql-snow {
  border: none;
}
</style>
